<header fxLayout="row" fxLayoutAlign="space-between center">
  <section class="title-container" fxLayout="row" fxLayoutAlign="space-between center">
    <img alt="logo" class="logo" src="./assets/logo_white.svg">
    <mat-divider class="horizontal-divider" vertical></mat-divider>
    <h2>SAP connector</h2>
  </section>
</header>
